import { Application } from '../enums/application.enum';
import { AppPermissionInheritance } from '../enums/app-permission-inheritance.enum';
import { ApplicationStatus } from '../enums/application-status.enum';

export interface IAppPermissionCreate {
  featureId: string;
  application: Application;
  description: string;
  status: ApplicationStatus;
  inheritanceType?: AppPermissionInheritance;
}

export interface IAppPermissionAssignment {
  featureId: string;
  inheritanceType: AppPermissionInheritance;
}

export type AppPermission = Omit<IAppPermissionCreate, 'description' | 'status'>;

interface IAppPermissionWithInheritance extends AppPermission {
  inheritanceType: AppPermissionInheritance;
}

export interface IOrganisationAppPermissionManagement {
  entityUid: string;
  directlyAssignedFeatures: IAppPermissionWithInheritance[];
  inheritedFeatures: AppPermission[];
}

export interface IOrganisationAppPermission {
  entityUid: string;
  features: AppPermission[];
}

export interface IAppPermissions {
  features: AppPermission[];
}
